<template>

    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row>
                        <Col>
                            <Form :model="formItem" :rules="ruleValidate" :label-width="90" label-position="right"
                                  ref="form">
                                <Form-item :label="t.exchange.createTime" prop="createTime">
                                    <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss" :editable="false"
                                                v-model="formItem.createTime" style="width: 100% !important"
                                                :placeholder="msgUtil.placeholderRequired(t.exchange.createTime)"
                                                :options="createTimeOption"
                                                @on-change="onCreateTimeChange">
                                    </DatePicker>
                                </Form-item>
                                <FormItem :label="t.exchange.jpy" prop="jpy">
                                    <InputNumber v-model="formItem.jpy" style="width: 100% !important"
                                                 :step="0.0001" :min="0"
                                                 :placeholder="msgUtil.placeholderRequired(t.exchange.jpy)"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.exchange.usd" prop="usd">
                                    <InputNumber v-model="formItem.usd" style="width: 100% !important"
                                                 :maxlength="10" :step="0.0001" :min="0"
                                                 :placeholder="msgUtil.placeholderRequired(t.exchange.usd)"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.exchange.hkd" prop="hkd">
                                    <InputNumber v-model="formItem.hkd" style="width: 100% !important"
                                                 :maxlength="10" :step="0.00001" :min="0"
                                                 :placeholder="msgUtil.placeholderRequired(t.exchange.hkd)"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.exchange.eur" prop="eur">
                                    <InputNumber v-model="formItem.eur" style="width: 100% !important"
                                                 :maxlength="10" :step="0.0001" :min="0"
                                                 :placeholder="msgUtil.placeholderRequired(t.exchange.eur)"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.exchange.gpb" prop="gpb">
                                    <InputNumber v-model="formItem.gpb" style="width: 100% !important"
                                                 :maxlength="10" :step="0.0001" :min="0"
                                                 :placeholder="msgUtil.placeholderRequired(t.exchange.gpb)"></InputNumber>
                                </FormItem>
                                <FormItem>
                                    <Button type="primary" :loading="loading" @click="handleSubmit()">
                                        {{msgUtil.message.action.submit}}
                                    </Button>
                                    <Button @click="handleReset()" style="margin-left: 8px">
                                        {{msgUtil.message.action.reset}}
                                    </Button>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
import { edit, getExchangeInfo } from '@/api/exchange';

export default {
    name: 'content_exchange_edit',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            formItemBk: {},
            formItem: {
                jpy: null,
                usd: null,
                hkd: null,
                eur: null,
                gpb: null,
                createTime: '',
            },
            ruleValidate: {
                createTime: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.exchange.year),
                        trigger: 'blur',
                    },
                ],
                jpy: [
                    {
                        type: 'number',
                        required: true,
                        message: msgUtil.errorRequired(t.exchange.jpy),
                        trigger: 'blur',
                    },
                ],
                usd: [
                    {
                        type: 'number',
                        required: true,
                        message: msgUtil.errorRequired(t.exchange.usd),
                        trigger: 'blur',
                    },
                ],
                hkd: [
                    {
                        type: 'number',
                        required: true,
                        message: msgUtil.errorRequired(t.exchange.hkd),
                        trigger: 'blur',
                    },
                ],
                eur: [
                    {
                        type: 'number',
                        required: true,
                        message: msgUtil.errorRequired(t.exchange.eur),
                        trigger: 'blur',
                    },
                ],
                gpb: [
                    {
                        type: 'number',
                        required: true,
                        message: msgUtil.errorRequired(t.exchange.gpb),
                        trigger: 'blur',
                    },
                ],
            },
            loading: false,
            createTimeOption: {},
        };
    },
    methods: {
        handleSubmit() {
            if (this.formItem.createTime instanceof Date) {
                this.formItem.createTime = this.formItem.createTime.format('yyyy/MM/dd HH:mm:ss');
                console.log(this.formItem.createTime);
            }
            this.loading = true;
            this.$Loading.start();
            this.$refs['form'].validate(async valid => {
                if (valid) {
                    this.loading = true;
                    let exchangeDto = {};
                    exchangeDto.createTime = this.formItem.createTime;
                    exchangeDto.jpy = this.formItem.jpy;
                    exchangeDto.usd = this.formItem.usd;
                    exchangeDto.hkd = this.formItem.hkd;
                    exchangeDto.eur = this.formItem.eur;
                    exchangeDto.gpb = this.formItem.gpb;
                    await edit(this.$route.params.id, exchangeDto);
                    Object.assign(this.formItemBk, this.formItem);
                    this.$Message.success(this.msgUtil.message.action.updateSuccess);
                    this.$Loading.finish();
                } else {
                    this.$Loading.error();
                    this.$Message.error(this.msgUtil.message.action.updateFail);
                }
            });
            this.loading = false;
        },

        handleReset() {
            Object.assign(this.formItem, this.formItemBk);
            this.loading = false;
        },
        async init() {
            const exchangeInfo = await getExchangeInfo(this.$route.params.id);
            if (exchangeInfo.exchange != null) {
                this.formItem.jpy = parseFloat(exchangeInfo.exchange.jpy);
                this.formItem.usd = parseFloat(exchangeInfo.exchange.usd);
                this.formItem.hkd = parseFloat(exchangeInfo.exchange.hkd);
                this.formItem.eur = parseFloat(exchangeInfo.exchange.eur);
                this.formItem.gpb = parseFloat(exchangeInfo.exchange.gpb);
                this.formItem.createTime = exchangeInfo.exchange.createTime;
                //this.formItem = exchangeInfo.exchange;
                Object.assign(this.formItemBk, exchangeInfo.exchange);
            }
        },
        onCreateTimeChange(createTime) {
            this.formItem.createTime = createTime;
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
